import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { login } from "../../../redux/_actions/userActions";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const dispatch = useDispatch();
  const history = useHistory();

  const userSignin = useSelector((state) => state.userSignin);
  const { loading } = userSignin;

  useEffect(() => {
    // Example side effect: check if user is already logged in
    if (userSignin.userInfo) {
      history.push("/dashboard");
    }
  }, [userSignin.userInfo, history]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password, history));
  };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="5">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={submitHandler}>
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        placeholder="Email"
                        autoComplete="email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type={passwordType}
                        placeholder="Password"
                        autoComplete="current-password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {passwordType === "password" ? (
                        <CButton
                          type="button"
                          color="secondary"
                          variant="outline"
                          onClick={() => setPasswordType("text")}
                        >
                          Show
                        </CButton>
                      ) : (
                        <CButton
                          type="button"
                          color="secondary"
                          variant="outline"
                          onClick={() => setPasswordType("password")}
                        >
                          Hide
                        </CButton>
                      )}
                    </CInputGroup>
                    <CRow>
                      <CCol xs="6">
                        {password.length < 3 ? (
                          <CButton
                            color="secondary"
                            className="px-4"
                            type="submit"
                            disabled
                          >
                            Login <i className="fa fa-angle-right ml-1"></i>
                          </CButton>
                        ) : (
                          <CButton
                            color="primary"
                            className="px-4"
                            type="submit"
                          >
                            {loading && (
                              <i className="fa fa-ellipsis-h fa-spin"></i>
                            )}
                            {loading && (
                              <span>
                                <i className="fa fa-angle-right ml-1"></i>
                              </span>
                            )}
                            {!loading && (
                              <span>
                                Login <i className="fa fa-angle-right ml-1"></i>
                              </span>
                            )}
                          </CButton>
                        )}
                      </CCol>
                      <CCol xs="6" className="text-right">
                        <Link to="/reset-password">
                          <CButton color="link" className="px-0">
                            Forgot password?
                          </CButton>
                        </Link>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default Login;
